export { default as View } from './view';
//# sourceMappingURL=index.js.map